import { render, staticRenderFns } from "./PrescriptionTitle.vue?vue&type=template&id=7de4e97c"
import script from "./PrescriptionTitle.vue?vue&type=script&lang=js"
export * from "./PrescriptionTitle.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionTitle.vue?vue&type=style&index=0&id=7de4e97c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports